/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import BaseTag from '../shared/base';
import Before from '../shared/before';
import Content from '../shared/content';
var SimpleTagComponent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var appearance = _ref.appearance,
    _ref$elemBefore = _ref.elemBefore,
    elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'standard' : _ref$color,
    href = _ref.href,
    testId = _ref.testId,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    linkComponent = _ref.linkComponent;
  var content = jsx(Content, {
    elemBefore: elemBefore,
    isRemovable: false,
    text: text,
    color: color,
    href: href,
    linkComponent: linkComponent
  });
  return jsx(BaseTag, {
    ref: ref,
    testId: testId,
    href: href,
    appearance: appearance,
    color: color,
    before: jsx(Before, {
      elemBefore: elemBefore
    }),
    contentElement: content
  });
});

/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */
var SimpleTag = /*#__PURE__*/memo(SimpleTagComponent);
export default SimpleTag;